export default "__VITE_ASSET__ed450ff8__"